/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  TelegramTransactionsUserControllerGetPartsForAmountMutationRequest,
  TelegramTransactionsUserControllerGetPartsForAmountMutationResponse,
  TelegramTransactionsUserControllerGetPartsForAmount400,
  TelegramTransactionsUserControllerGetPartsForAmount401,
  TelegramTransactionsUserControllerGetPartsForAmount404,
} from '../../types/TelegramTransactionsUserControllerGetPartsForAmount.ts';
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query';
import { telegramTransactionsUserGetPartsForAmount } from '../../methods/telegramTransactionsUserGetPartsForAmount.ts';
import { useMutation } from '@tanstack/react-query';

export const telegramTransactionsUserGetPartsForAmountMutationKey = () =>
  [{ url: '/api/user/telegram/transactions/parts-by-amount' }] as const;

export type TelegramTransactionsUserGetPartsForAmountMutationKey = ReturnType<
  typeof telegramTransactionsUserGetPartsForAmountMutationKey
>;

/**
 * {@link /api/user/telegram/transactions/parts-by-amount}
 */
export function useTelegramTransactionsUserGetPartsForAmount<TContext>(
  options: {
    mutation?: UseMutationOptions<
      TelegramTransactionsUserControllerGetPartsForAmountMutationResponse,
      ResponseErrorConfig<
        | TelegramTransactionsUserControllerGetPartsForAmount400
        | TelegramTransactionsUserControllerGetPartsForAmount401
        | TelegramTransactionsUserControllerGetPartsForAmount404
      >,
      { data?: TelegramTransactionsUserControllerGetPartsForAmountMutationRequest },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<TelegramTransactionsUserControllerGetPartsForAmountMutationRequest>> & {
      client?: typeof fetch;
    };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? telegramTransactionsUserGetPartsForAmountMutationKey();

  return useMutation<
    TelegramTransactionsUserControllerGetPartsForAmountMutationResponse,
    ResponseErrorConfig<
      | TelegramTransactionsUserControllerGetPartsForAmount400
      | TelegramTransactionsUserControllerGetPartsForAmount401
      | TelegramTransactionsUserControllerGetPartsForAmount404
    >,
    { data?: TelegramTransactionsUserControllerGetPartsForAmountMutationRequest },
    TContext
  >(
    {
      mutationFn: async ({ data }) => {
        return telegramTransactionsUserGetPartsForAmount(data, config);
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  );
}
